import { Component, ErrorInfo, ReactNode } from 'react'
import AppConnectError from '@Shared/components/AppConnectError'
import EmptyLayout from '@Layouts/EmptyLayout'
import { PrisyncError } from '@Types/PrisyncError'
import Sentry from '@Utils/Sentry'

type GuardErrorBoundaryProps = {
  children: ReactNode
}

type GuardErrorBoundaryState = {
  hasError: boolean
  error: PrisyncError | Error | null
}

class GuardErrorBoundary extends Component<
  GuardErrorBoundaryProps,
  GuardErrorBoundaryState
> {
  constructor(props: GuardErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('GuardErrorBoundary caught an error', error, errorInfo)

    Sentry.captureReactException(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <EmptyLayout>
          <AppConnectError
            {...(this.state.error?.message
              ? { errorMessage: this.state.error?.message }
              : {})}
          />
        </EmptyLayout>
      )
    }

    return this.props.children
  }
}

export default GuardErrorBoundary
